import { CustomFile, DriveTask, uploadToDrive } from "../../../../Helpers/file";
import { Deferred } from "../../../../Helpers/Deferred";
import { FormStore } from "../../../Core/Store/CandyStore";
import { IFormModelAccessor } from "../../../Form/IFormModelAccessor";
import { setAttachmentProgress } from "../Store/AttachmentsActions";
import { BindingPath } from "../../../Core/CoreTypes";
import { AbsoluteResolvedModelPath } from "../../../../../../Common/ModelPath/ModelPath";

import { ITask } from "./ITask";

let nextUploadDeferred: Deferred<void> | undefined;

export function suspendNextUpload(): void {
    if (nextUploadDeferred != undefined) {
        throw new Error("There are suspended upload. Please resume one.");
    }
    nextUploadDeferred = new Deferred();
}

export function resumeLastSuspendedUpload(): void {
    if (nextUploadDeferred != undefined) {
        nextUploadDeferred.resolve();
        nextUploadDeferred = undefined;
    } else {
        throw new Error("There are no suspended uploads");
    }
}

export class UploadToDriveTask implements ITask {
    private readonly store: FormStore;
    private readonly file: CustomFile;
    private driveTask?: DriveTask;
    private readonly attachmentId: string;
    private readonly isConvert: boolean;
    private readonly bindingPath: BindingPath | AbsoluteResolvedModelPath;
    private readonly modelAccessor: IFormModelAccessor;
    public taskPromise: Promise<void>;
    private cancelled = false;

    public constructor(
        store: FormStore,
        modelAccessor: IFormModelAccessor,
        attachmentId: string,
        bindingPath: BindingPath | AbsoluteResolvedModelPath,
        file: CustomFile,
        isConvert: boolean,
        writeResultFunc: (contentUri: string | undefined) => Promise<void>
    ) {
        this.modelAccessor = modelAccessor;
        this.store = store;
        this.bindingPath = bindingPath;
        this.file = file;
        this.attachmentId = attachmentId;
        this.isConvert = isConvert;

        this.taskPromise = this.startTask().then(contentUri => writeResultFunc(contentUri));
    }

    public cancel(): void {
        if (this.driveTask) {
            this.driveTask.cancel();
        }
        this.cancelled = true;
    }

    public startTask(): Promise<string | undefined> {
        // Так-то тут надо просто uploadToDrive сделать так, чтобы он там был промисом
        // eslint-disable-next-line no-async-promise-executor
        return new Promise<string | undefined>(async (resolve, reject) => {
            if (nextUploadDeferred != undefined) {
                await nextUploadDeferred.promise;
                if (this.cancelled) {
                    return;
                }
            }
            // Иначе Promise без cancel
            const { initDrive, getDriveTask } = uploadToDrive(this.file, this.handleChangeUploadToDriveProgress);

            await initDrive;
            this.driveTask = getDriveTask();
            this.driveTask.then(resolve, reject);
        }).catch(() => {
            this.modelAccessor.addError(
                this.bindingPath,
                "Не удалось загрузить документ, попробуйте ещё раз через несколько минут"
            );
            return undefined;
        });
    }

    private readonly handleChangeUploadToDriveProgress = (current: number, total: number) => {
        const maxLoad = this.isConvert ? 80 : 100;
        const percent = total > 0 ? Math.floor((current / total) * maxLoad) : 0;

        this.store.dispatch(setAttachmentProgress(this.attachmentId, percent));
    };
}
